import type { ImgHTMLAttributes } from "react";

type BrandImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src: string;
  wrapperClassName?: string;
};

function isWholesaleCatalogueImage(src: string) {
  try {
    const url = new URL(src, window.location.origin);
    return url.hostname === "files.99bulksales.my" || url.pathname.startsWith("/brand-source-images/");
  } catch {
    return false;
  }
}

export default function BrandImage({ src, alt = "", wrapperClassName = "", className = "", ...imageProps }: BrandImageProps) {
  const catalogueClass = isWholesaleCatalogueImage(src) ? " brand-unit-image--catalogue" : "";
  return (
    <span
      className={`brand-unit-image${catalogueClass}${wrapperClassName ? ` ${wrapperClassName}` : ""}`}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
    >
      <img {...imageProps} src={src} alt="" className={className} />
    </span>
  );
}
